import RedirectHome from './RedirectHome.jsx'

export default RedirectHome;



// WEBPACK FOOTER //
// ./src/components/RedirectHome/index.js